var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-menu'),_vm._v(" "),_vm._t("modals"),_vm._v(" "),_c('section',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._t("default")],2)])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748d78a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/layouts/boxDefault.vue
// module id = 690
// module chunks = 0